interface iBellaTimerNewsletter {
  first_time_date?: string
}
export const newsletterStore = defineStore('newsletter', {
  state: () => ({
    bellaTimerNewsletter: {} as iBellaTimerNewsletter
  }),
  actions: {
    async setNewsletterParams(payload: object) {
      this.bellaTimerNewsletter = payload
    },
    async resetNewsletterParams() {
      sessionStorage.removeItem('bellaTimerNewsletter');
    }
  },
  persist: {
    key: 'bellaTimerNewsletter',
    storage: piniaPluginPersistedstate.sessionStorage(),
  }
})
